if (!customElements.get("pickup-availability")) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute("available")) return;

      this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.baseUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
          this.renderPreview(sectionInnerHTML);
        })
        .catch((e) => {
          const button = this.querySelector("button");
          if (button) button.removeEventListener("click", this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = "";
      }
    }

    renderError() {
      this.innerHTML = "";
      this.appendChild(this.errorHtml);

      this.querySelector("button").addEventListener("click", this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector("#Drawer-Pickup-Availability");
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
        this.innerHTML = "";
        this.removeAttribute("available");
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
      this.setAttribute("available", "");

      document.body.appendChild(sectionInnerHTML.querySelector("#Drawer-Pickup-Availability"));

      const button = this.querySelector("button");

      if (button) {
        button.addEventListener("click", (e) => {
          document.querySelector("#Drawer-Pickup-Availability").openDrawer(e.currentTarget);
        });
      }
    }
  }

  customElements.define("pickup-availability", PickupAvailability);
}

if (!customElements.get("pickup-availability-drawer")) {
  class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.drawerWapper = this.querySelector(".m-drawer__wrapper");
      this.drawerContent = this.querySelector(".m-drawer__content");
      this.drawerClose = this.querySelector(".m-drawer__close");

      this.drawerClose.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeDrawer();
      });

      this.addEventListener("click", (e) => {
        if (e.target === this.drawerWapper) this.closeDrawer();
      });
      this.keepFocusInDrawer = (event) => {
        if (this.isOpen && !this.contains(event.target)) this.drawerClose.focus();
      };
      this.addEventListener("keydown", (event) => {
        if (!this.isOpen) return;
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          this.closeDrawer();
          return;
        }
        if (event.key !== "Tab") return;
        const controls = Array.from(this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'))
          .filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== "hidden" && !element.closest('[inert],[hidden]'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openFrame);
      document.removeEventListener("focusin", this.keepFocusInDrawer);
      if (this.isOpen) document.documentElement.classList.remove("prevent-scroll");
    }

    openDrawer(trigger = document.activeElement) {
      if (this.isOpen) return;
      clearTimeout(this.closeTimer);
      this.returnFocus = trigger;
      this.returnFocus.setAttribute("aria-expanded", "true");
      this.isOpen = true;
      this.removeAttribute("inert");
      this.setAttribute("aria-hidden", "false");
      if (window.innerWidth < 770) {
        document.documentElement.classList.add("prevent-scroll");
        this.drawerWapper.classList.add("mobile");
      }
      this.drawerWapper.classList.remove("m:hidden");
      this.openFrame = requestAnimationFrame(() => {
        if (!this.isOpen) return;
        this.drawerWapper.style.setProperty("--m-bg-opacity", "0.5");
        this.drawerContent.style.setProperty("--m-translate-x", "0");
        this.drawerClose.focus();
      });
      document.addEventListener("focusin", this.keepFocusInDrawer);
    }

    closeDrawer() {
      if (!this.isOpen) return;
      this.isOpen = false;
      cancelAnimationFrame(this.openFrame);
      document.removeEventListener("focusin", this.keepFocusInDrawer);
      if (this.returnFocus && this.returnFocus.isConnected) {
        this.returnFocus.setAttribute("aria-expanded", "false");
        this.returnFocus.focus();
      }
      this.setAttribute("inert", "");
      this.setAttribute("aria-hidden", "true");
      this.drawerWapper.style.setProperty("--m-bg-opacity", "0");
      this.drawerContent.style.setProperty("--m-translate-x", "100%");
      this.closeTimer = setTimeout(() => {
        this.drawerWapper.classList.add("m:hidden");
        this.drawerWapper.classList.remove("mobile");
        document.documentElement.classList.remove("prevent-scroll");
      }, 300);
    }
  }

  customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
}
